(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfKeypress', [
    '$document', '$rootScope', function($document, $rootScope) {
      return {
        restrict: 'A',
        link: (function(_this) {
          return function() {
            return $document.bind('keypress', function(event) {
              $rootScope.$broadcast('keypress', event);
              $rootScope.$broadcast("keypress:" + event.which, event);
              return $rootScope.$apply();
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
